/**
 * main-product.js
 * Shopify Main Product Section – Full Interactive Functionality
 * - Gallery: thumbnail navigation, main image swap, lightbox
 * - Size selector: variant switch, price update
 * - Quantity stepper
 * - Add to Cart (AJAX)
 * - Buy Now (direct checkout)
 * - Sold counter animation
 * - Reveal on scroll
 */

(function () {
  'use strict';

  /* ===========================================================
     UTILITY
  =========================================================== */
  function qs(selector, ctx) {
    return (ctx || document).querySelector(selector);
  }
  function qsa(selector, ctx) {
    return [...(ctx || document).querySelectorAll(selector)];
  }

  /* ===========================================================
     1. GALLERY
  =========================================================== */
  class ProductGallery {
    constructor(section) {
      this.section = section;
      // this.mainImg = qs('#gallery-active-img', section);
      this.thumbTrack = qs('#gallery-thumbs-track', section);
      this.thumbViewport = qs('#gallery-thumbs-viewport', section);
      this.btnPrev = qs('#thumb-prev', section);
      this.btnNext = qs('#thumb-next', section);
      this.thumbCards = qsa('.thumb-card', section);
      this.lightbox = null;
      this.currentIndex = 0;
      this.thumbOffset = 0;
      this.thumbWidth = 80; // card width + gap

      if (!this.thumbTrack) return;
      this.init();
    }

    init() {
      // Thumb click → swap main image
      this.thumbCards.forEach((card, idx) => {
        card.addEventListener('click', () => this.setActive(idx));
      });

      // Prev/Next navigation
      this.btnPrev && this.btnPrev.addEventListener('click', () => this.scroll(-1));
      this.btnNext && this.btnNext.addEventListener('click', () => this.scroll(1));

      // Lightbox on main image click
      const mainWrap = qs('.gallery-main-image-wrap', this.section);
      mainWrap && mainWrap.addEventListener('click', () => this.openLightbox());

      // Keyboard support on thumbs
      this.thumbCards.forEach((card) => {
        card.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const idx = parseInt(card.dataset.index, 10) || 0;
            this.setActive(idx);
          }
        });
      });

      this.updateNavBtns();
      this.buildLightbox();
    }

    setActive(idx) {
      const card = this.thumbCards[idx];
      if (!card) return;

      this.thumbCards.forEach(c => c.classList.remove('thumb-card--active'));
      card.classList.add('thumb-card--active');
      this.currentIndex = idx;

      const mediaType = card.dataset.mediaType;
const mediaSrc = card.dataset.mediaSrc;
const newAlt = card.dataset.imgAlt || '';

const mainContainer = qs('#gallery-main-image', this.section);

if (!mainContainer) return;

// IMAGE
if (mediaType === 'image') {
  mainContainer.innerHTML = `
    <img 
      id="gallery-active-img"
      src="${mediaSrc}" 
      alt="${newAlt}" 
      class="gallery-img"
    >
  `;
}

// VIDEO
if (mediaType === 'video') {
  mainContainer.innerHTML = `
  <div class="video-wrapper">
    <video controls autoplay playsinline>
      <source src="${mediaSrc}" type="video/mp4">
    </video>
  </div>
  `;
}

      // Update lightbox src if open
      const lbImg = this.lightbox && qs('.lb-active-img', this.lightbox);
      if (lbImg && newSrc) lbImg.src = newSrc;
    }

    scroll(dir) {
      const viewportW = this.thumbViewport ? this.thumbViewport.offsetWidth : 0;
      const trackW = this.thumbTrack ? this.thumbTrack.scrollWidth : 0;
      const maxOffset = Math.max(0, trackW - viewportW);

      this.thumbOffset = Math.max(0, Math.min(this.thumbOffset + dir * this.thumbWidth * 2, maxOffset));
      this.thumbTrack.style.transform = `translateX(-${this.thumbOffset}px)`;
      this.updateNavBtns();
    }

    updateNavBtns() {
      const viewportW = this.thumbViewport ? this.thumbViewport.offsetWidth : 0;
      const trackW = this.thumbTrack ? this.thumbTrack.scrollWidth : 0;
      const maxOffset = Math.max(0, trackW - viewportW);

      if (this.btnPrev) this.btnPrev.disabled = this.thumbOffset <= 0;
      if (this.btnNext) this.btnNext.disabled = this.thumbOffset >= maxOffset;
    }

    buildLightbox() {
      const lb = document.createElement('div');
      lb.className = 'gallery-lightbox';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Product image zoom');
      lb.innerHTML = `
        <img class="lb-active-img" src="" alt="" style="max-width:90vw;max-height:90vh;object-fit:contain;border-radius:12px;">
        <button class="gallery-lightbox-close" aria-label="Close zoom">&times;</button>
      `;
      document.body.appendChild(lb);
      this.lightbox = lb;

      lb.addEventListener('click', (e) => {
        if (e.target === lb || e.target.classList.contains('gallery-lightbox-close')) {
          this.closeLightbox();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && lb.classList.contains('is-open')) {
          this.closeLightbox();
        }
      });
    }

    openLightbox() {
      if (!this.lightbox || !this.mainImg) return;
      const lbImg = qs('.lb-active-img', this.lightbox);
      if (lbImg) {
        lbImg.src = this.mainImg.src;
        lbImg.alt = this.mainImg.alt;
      }
      this.lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    closeLightbox() {
      if (!this.lightbox) return;
      this.lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  /* ===========================================================
     2. SIZE SELECTOR / VARIANT SWITCHER
  =========================================================== */
//   class VariantSelector {
//   constructor(section) {
//     this.section = section;
//     this.sizeBtns = qsa('.size-btn', section);
//     this.selectedLabel = qs('#selected-size-label', section);
//     this.variantInput = qs('#product-variant-id', section);
//     this.init();
//   }

//   init() {
//     this.sizeBtns.forEach(btn => {
//       if (btn.getAttribute('aria-disabled') === 'true') return;
//       btn.addEventListener('click', () => this.selectVariant(btn));
//     });
//   }

//   selectVariant(btn) {
//     // Active state
//     this.sizeBtns.forEach(b => b.classList.remove('size-btn--active'));
//     btn.classList.add('size-btn--active');

//     const variantId = btn.dataset.variantId;
//     const price = parseInt(btn.dataset.price, 10);
//     const comparePrice = parseInt(btn.dataset.comparePrice, 10) || 0;
//     const available = btn.dataset.available === 'true';

//     // Update variant ID (IMPORTANT)
//     if (this.variantInput) this.variantInput.value = variantId;

//     // Update selected label
//     if (this.selectedLabel) {
//       this.selectedLabel.textContent = btn.textContent.trim();
//     }

//     // Update price
//     this.updatePrice(price, comparePrice);

//     // Update Add to Cart button
//     const atcBtn = qs('#add-to-cart-btn', this.section);
//     const buyNowBtn = qs('#buy-now-btn', this.section);

//     if (atcBtn) {
//       atcBtn.disabled = !available;
//       const atcText = qs('.atc-text', atcBtn);
//       if (atcText) {
//         atcText.textContent = available ? 'Add To Cart' : 'Sold Out';
//       }
//     }

//     if (buyNowBtn) buyNowBtn.disabled = !available;
//   }

//   updatePrice(price, comparePrice) {
//     const block = qs('.product-block--price', this.section);
//     if (!block) return;

//     const saleEl = qs('.price-item--sale', block);
//     const regularEl = qs('.price-item--regular', block);

//     // Update current price
//     if (saleEl) {
//       saleEl.textContent = this.formatMoney(price);
//     } else if (regularEl) {
//       regularEl.textContent = this.formatMoney(price);
//     }

//     // Update compare price (if exists)
//     if (comparePrice > price && regularEl) {
//       regularEl.textContent = this.formatMoney(comparePrice);
//     }
//   }

//   formatMoney(cents) {
//     const amount = (cents / 100).toFixed(2);
//     return `Rs. ${amount}`;
//   }
// }

  /* ===========================================================
     3. QUANTITY STEPPER
  =========================================================== */
  class QuantityStepper {
    constructor(section) {
      this.section = section;
      // Allow multiple sections (section.id used in IDs)
      qsa('.qty-btn--minus', section).forEach(btn => {
        btn.addEventListener('click', () => this.adjustQty(btn, -1));
      });
      qsa('.qty-btn--plus', section).forEach(btn => {
        btn.addEventListener('click', () => this.adjustQty(btn, 1));
      });
      qsa('.qty-input', section).forEach(input => {
        input.addEventListener('change', () => this.validateInput(input));
      });
    }

    adjustQty(btn, delta) {
      const stepper = btn.closest('.quantity-stepper');
      const input = qs('.qty-input', stepper);
      if (!input) return;
      const newVal = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + delta));
      input.value = newVal;
      this.syncHiddenInput(newVal);
    }

    validateInput(input) {
      const val = parseInt(input.value, 10);
      if (isNaN(val) || val < 1) input.value = 1;
      if (val > 99) input.value = 99;
      this.syncHiddenInput(parseInt(input.value, 10));
    }

    syncHiddenInput(qty) {
      const hiddenQty = qs('#product-quantity-input', this.section);
      if (hiddenQty) hiddenQty.value = qty;
    }
  }

  /* ===========================================================
     4. ADD TO CART (AJAX)
  =========================================================== */
  class AddToCart {
    constructor(section) {
      this.section = section;
      this.btn = qs('#add-to-cart-btn', section);
      this.form = qs(`#product-form-${section.dataset.sectionId}`, section);
      if (!this.btn) return;
      this.btn.addEventListener('click', () => this.addToCart());
    }

    async addToCart() {
      // const variantId = (qs('#product-variant-id', this.section) || {}).value;
      const variantId = qs('input[name="id"]', this.section)?.value;
      const quantity = parseInt((qs('#product-quantity-input', this.section) || {}).value || 1, 10);

      if (!variantId) {
        this.showToast('⚠️ Please select a variant', true);
        return;
      }

      this.setLoading(true);

      try {
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        });

        if (!resp.ok) {
          const err = await resp.json();
          throw new Error(err.description || 'Could not add item');
        }

        await resp.json();
        this.showToast('✅ Added to cart!');
        this.updateCartCount();

      } catch (err) {
        this.showToast(`⚠️ ${err.message}`, true);
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(state) {
      if (!this.btn) return;
      this.btn.classList.toggle('is-loading', state);
      this.btn.disabled = state;
      const loading = qs('.atc-loading', this.btn);
      if (loading) loading.style.display = state ? 'flex' : 'none';
    }

    async updateCartCount() {
  try {
    const resp = await fetch('/cart.js');
    const cart = await resp.json();

    const bubble = document.querySelector('.cart-count-bubble');
    const countEl = document.querySelector('.cart-count-bubble span');

    if (countEl) {
      countEl.textContent = cart.item_count;
    }

    if (bubble) {
      bubble.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }

  } catch (e) {
    console.error(e);
  }
}

    showToast(msg, isError = false) {
      let toast = qs('.cart-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'cart-toast';
        document.body.appendChild(toast);
      }
      toast.innerHTML = msg;
      if (isError) toast.style.background = '#dc2626';
      else toast.style.background = '#111827';
      toast.classList.add('is-visible');
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 3000);
    }
  }

  /* ===========================================================
     5. BUY NOW
  =========================================================== */
  class BuyNow {
    constructor(section) {
      this.section = section;
      this.btn = qs('#buy-now-btn', section);
      if (!this.btn) return;
      this.btn.addEventListener('click', () => this.buyNow());
    }

    async buyNow() {
      const variantId = (qs('#product-variant-id', this.section) || {}).value;
      const quantity = parseInt((qs('#product-quantity-input', this.section) || {}).value || 1, 10);

      if (!variantId) return;

      this.btn.disabled = true;
      this.btn.textContent = 'Processing…';

      try {
        // Clear cart, add item, redirect to checkout
        await fetch('/cart/clear.js', { method: 'POST' });

        // const resp = await fetch('/cart/add.js', {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify({ id: variantId, quantity: quantity })
        // });

        if (!resp.ok) throw new Error();

        window.location.href = '/checkout';

      } catch (_) {
        this.btn.disabled = false;
        this.btn.textContent = 'Buy It Now';
      }
    }
  }

  /* ===========================================================
     6. SOLD COUNTER ANIMATION
  =========================================================== */
  function initSoldCounter(section) {
    const el = qs('.sold-count', section);
    if (!el) return;

    const base = parseInt(el.dataset.base, 10) || 700;
    // Animate to slightly above base
    let current = base;
    const target = base + Math.floor(Math.random() * 15) + 5;

    function easeOut(t) { return 1 - Math.pow(1 - t, 3); }

    let start = null;
    const duration = 1800;

    function step(timestamp) {
      if (!start) start = timestamp;
      const elapsed = timestamp - start;
      const progress = Math.min(elapsed / duration, 1);
      current = Math.floor(base + (target - base) * easeOut(progress));
      el.textContent = current + '+';
      if (progress < 1) requestAnimationFrame(step);
    }

    // Start animation when element enters viewport
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        requestAnimationFrame(step);
        observer.disconnect();
      }
    }, { threshold: 0.3 });
    observer.observe(el);
  }

  /* ===========================================================
     7. REVEAL ON SCROLL
  =========================================================== */
  function initRevealOnScroll(section) {
    const elements = qsa('.reveal-on-scroll', section);
    if (!elements.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          // Stagger each block slightly
          const delay = parseInt(entry.target.dataset.revealDelay || 0, 10);
          setTimeout(() => {
            entry.target.classList.add('is-visible');
          }, delay);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    // Assign stagger delays
    elements.forEach((el, i) => {
      el.dataset.revealDelay = i * 60;
      observer.observe(el);
    });
  }

  /* ===========================================================
     8. STICKY GALLERY LOGIC
     Keeps gallery sticky while right column is taller,
     then unsticks. Also handles mobile.
  =========================================================== */
  function initStickyGallery() {
    const galleryCol = qs('.product-gallery-col');
    if (!galleryCol) return;

    function updateStickyTop() {
      // Account for any sticky header bar above
      const header = qs('header, .header, #shopify-section-header, .site-header, sticky-header');
      const headerH = header ? header.offsetHeight : 0;
      const offset = headerH + 20;
      galleryCol.style.top = offset + 'px';
    }

    updateStickyTop();
    window.addEventListener('resize', updateStickyTop);
  }

  /* ===========================================================
     INIT
  =========================================================== */
  function init() {
    qsa('.main-product-section').forEach(section => {
      new ProductGallery(section);
      // new VariantSelector(section);
      new QuantityStepper(section);
      new AddToCart(section);
      new BuyNow(section);
      initSoldCounter(section);
      initRevealOnScroll(section);
    });

    initStickyGallery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor support – re-init on section reload
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.main-product-section');
    if (!section) return;
    new ProductGallery(section);
    // new VariantSelector(section);
    new QuantityStepper(section);
    new AddToCart(section);
    new BuyNow(section);
    initSoldCounter(section);
    initRevealOnScroll(section);
    initStickyGallery();
  });

})();

